var map = {
	"./@best.svg": 28,
	"./@blunder.svg": 29,
	"./@book.svg": 30,
	"./@brilliant.svg": 31,
	"./@excellent.svg": 32,
	"./@good.svg": 33,
	"./@inaccuracy.svg": 34,
	"./@missed_win.svg": 35,
	"./@mistake.svg": 36,
	"./alternative.svg": 37,
	"./checkmate_black.svg": 38,
	"./checkmate_white.svg": 39,
	"./correct.svg": 40,
	"./critical.svg": 41,
	"./draw_black.svg": 42,
	"./draw_white.svg": 43,
	"./fast_win.svg": 44,
	"./forced.svg": 45,
	"./free_piece.svg": 46,
	"./great_find.svg": 47,
	"./incorrect.svg": 48,
	"./mate.svg": 49,
	"./resign_black.svg": 50,
	"./resign_white.svg": 51,
	"./sharp.svg": 52,
	"./take_back.svg": 53,
	"./threat.svg": 54,
	"./unnamed_clock_black.svg": 55,
	"./unnamed_clock_white.svg": 56,
	"./unnamed_redo.svg": 57,
	"./unnamed_updown_arrow.svg": 58,
	"./winner.svg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;